<template>
  <StellarCollectGame/>
</template>

<script>
import StellarCollectGame from '@/components/StellarCollectGame.vue'

export default {
  name: 'StellarCollectView',
  components: {
    StellarCollectGame
  }
}
</script>
